"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("./ListItem"));

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _Typography = require("../Typography");

var _List = _interopRequireDefault(require("./List.style"));

var List = function List(_ref) {
  var bg = _ref.bg,
      items = _ref.items,
      title = _ref.title,
      copy = _ref.copy,
      id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    bg: bg,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, null, title && /*#__PURE__*/_react.default.createElement(_Typography.PageTitle, {
    mb: "large"
  }, title), copy && /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    mb: "large"
  }, copy), items && items.map(function (item, key) {
    return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
      key: key.toString(),
      date: item.date,
      copy: item.copy
    });
  })));
};

List.propTypes = {
  id: _propTypes.default.string,
  bg: _propTypes.default.oneOf(['primary', 'secondary']),
  copy: _propTypes.default.string,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    copy: _propTypes.default.string.isRequired,
    date: _propTypes.default.string
  })).isRequired,
  title: _propTypes.default.string
};
List.defaultProps = {
  id: '',
  bg: 'primary',
  copy: '',
  title: ''
};
var _default = List;
exports.default = _default;